module.exports = __webpack_public_path__ + "img/4_13.a49be252.png";